<template>
  <div class="answer">
    <event-message v-if="status && isNotAnswerTime" />
    <answer-sheet v-else />
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import AnswerSheet from '@/components/Answer/Sheet'
import EventMessage from '@/components/Map/Event/Message'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    AnswerSheet,
    EventMessage
  },

  created: async function () {
    await this.$store.dispatch('event/fetchPlaying')
  },

  computed: {
    status: function () {
      return this.$store.state.event.status
    },

    isNotAnswerTime: function () {
      return this.status !== 'eventIsAnswerTime'
    }
  }
}
</script>

<style lang="scss" scoped>
.answer {
  @include caption-center-base;
}
</style>
